import Content404 from './Content404';

export default Content404;
